export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxUl0c5yjTjQJElti5.ada3de2b.woff2";